module.exports = __webpack_public_path__ + "img/archoshell.7e2e1028.png";